var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { Modal } from '../Modal';
import { Typography } from 'designSystem';
import { SendCode } from './States/SendCode';
import { EnterCodeAndPassword } from './States/EnterCodeAndPassword';
import { PasswordResetSuccessful } from './States/PasswordResetSuccessful';
import { ForgotTempPassword } from './States/ForgotTempPassword';
import { TemporaryPasswordSent } from './States/TemporaryPasswordSent';
export var ForgotPassword = function () {
    var _a = __read(useState(''), 2), emailAddress = _a[0], setEmailAddress = _a[1];
    var _b = __read(useState(false), 2), verificationSent = _b[0], setVerificationSent = _b[1];
    var _c = __read(useState(false), 2), passwordReset = _c[0], setPasswordReset = _c[1];
    var _d = __read(useState(false), 2), resendTemp = _d[0], setResendTemp = _d[1];
    var _e = __read(useState(false), 2), tempResent = _e[0], setTempResent = _e[1];
    var _f = __read(useState(null), 2), error = _f[0], setError = _f[1];
    var _g = __read(useState(false), 2), isLoading = _g[0], setIsLoading = _g[1];
    var theme = useTheme();
    var getVerificationCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setError(null);
            setIsLoading(true);
            try {
                setVerificationSent(true);
            }
            catch (e) {
                if ((e === null || e === void 0 ? void 0 : e.code) === 'NotAuthorizedException') {
                    setResendTemp(true);
                }
                else if ((e === null || e === void 0 ? void 0 : e.code) === 'UserNotFoundException') {
                    setVerificationSent(true);
                }
                else {
                    setError(e);
                }
            }
            finally {
                setIsLoading(false);
            }
            return [2];
        });
    }); };
    var renderError = function () {
        if ((error === null || error === void 0 ? void 0 : error.code) === 'ExpiredCodeException' ||
            (error === null || error === void 0 ? void 0 : error.code) === 'CodeMismatchException' ||
            (error === null || error === void 0 ? void 0 : error.code) === 'LimitExceededException') {
            return (React.createElement(ErrorContainer, null,
                React.createElement(RightIconContainer, null,
                    React.createElement(ErrorIconImage, { src: require('../../../designSystem/components/Input/input-error.png'), alt: "input-error-image" })),
                React.createElement(Typography, { variant: "footnote", color: "link" }, error === null || error === void 0 ? void 0 : error.message)));
        }
        return null;
    };
    var renderContent = function () {
        if (passwordReset) {
            return React.createElement(PasswordResetSuccessful, null);
        }
        if (verificationSent) {
            return (React.createElement(EnterCodeAndPassword, { setPasswordReset: setPasswordReset, isLoading: isLoading, setError: setError, setIsLoading: setIsLoading, emailAddress: emailAddress, error: error, renderedError: renderError(), getVerificationCode: getVerificationCode }));
        }
        if (tempResent) {
            return React.createElement(TemporaryPasswordSent, null);
        }
        if (resendTemp) {
            return (React.createElement(ForgotTempPassword, { onTempResent: function () { return setTempResent(true); }, email: emailAddress }));
        }
        return (React.createElement(SendCode, { emailAddress: emailAddress, isLoading: isLoading, setEmailAddress: setEmailAddress, renderedError: renderError(), getVerificationCode: getVerificationCode }));
    };
    return (React.createElement(Modal, { scrollable: true, backdropColor: theme.colors.bg.accent, size: passwordReset ? 'medium' : 'large' }, renderContent()));
};
var ErrorContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin-bottom: 24px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin-bottom: 24px;\n"])));
var RightIconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ErrorIconImage = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 1rem;\n  height: 1rem;\n  margin-right: 8px;\n"], ["\n  width: 1rem;\n  height: 1rem;\n  margin-right: 8px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
